<h3 class="ui primary header" style="text-transform: uppercase">
  Verify {{ request?.changeRequestType.replaceAll("_", " ") }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div *ngIf="success || error" tamsyMargin marginY="10px">
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
  <esl-message-toast [(message)]="error"></esl-message-toast>
</div>
<div class="content ui basic segment" [ngClass]="{'loading':pending}">
  <div class="scroll-wrapper">
    <!--Laboratory form  -->
    <div class="item">
      <div class="card">
        <h3
          style="
            font-weight: 700;
            font-size: 11px;
            line-height: 131.69%;
            color: #828282;
          "
        >
          CREATED BY
        </h3>
        <div class="flex">
          <div class="flex">
            <img
              src="../../../../../assets/icons/person.svg"
              style="margin-right: 8px"
              alt="person"
            />
            <p
              style="
                font-weight: 400;
                font-size: 14px;
                line-height: 16px;
                color: #828282;
              "
            >
              {{request?.changeRequest.createdBy|createdBy}}
            </p>
          </div>
          <div class="flex" style="padding-left: 25px">
            <img
              src="../../../../../assets/icons/clock.svg"
              style="margin-right: 8px"
              alt="clock"
            />
            <p
              style="
                font-weight: 400;
                font-size: 14px;
                line-height: 16px;
                color: #828282;
              "
            >
              {{request?.changeRequest.dateCreated | date:'d, MMMM y, h:mma'}}
            </p>
          </div>
        </div>
      </div>
      <div class="info" *ngIf="type==='OFFICIAL_DOCUMENT'">
        <h2
          style="
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;
            color: #3f4395;
          "
        >
          Official Documents
        </h2>
        <div class="ui divider"></div>
        <div class="item" style="margin-bottom: 30px">
          <h4
            style="
              font-weight: 700;
              font-size: 11px;
              line-height: 131.69%;
              color: #505050;
            "
          >
            DOCUMENT NAME
          </h4>
          <p
            style="
              font-weight: 400;
              font-size: 14px;
              line-height: 19px;
              color: #505050;
              margin-top: '-5px';
            "
          >
            {{toValue?.documentName}}
          </p>
        </div>
        <div class="item" style="margin-bottom: 30px">
          <h4
            style="
              font-weight: 700;
              font-size: 11px;
              line-height: 131.69%;
              color: #505050;
            "
          >
            DOCUMENT TYPE NAME
          </h4>
          <p
            style="
              font-weight: 400;
              font-size: 14px;
              line-height: 19px;
              color: #505050;
              margin-top: '-5px';
            "
          >
            {{ documentType}}
          </p>
        </div>
      </div>
      <div class="info" *ngIf="personnelStructures.includes(type)">
        <h2
          style="
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;
            color: #3f4395;
          "
        >
          {{getType(type) | titlecase}}
        </h2>
        <div class="ui divider"></div>
        <h2
          style="
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;
            color: #3f4395;
          "
        >
          Previous {{getType(type) | titlecase}} Records
        </h2>
        <div *ngFor="let data of fromValue; let i=index;">
          <sui-accordion [closeOthers]="false">
            <sui-accordion-panel [isOpen]="false">
              <div
                title
                [ngClass]="{
                  '#e5e7eb':open,
                  '#f9fafb': !open
                }"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  height: 89px;
                  background-color: #f9fafb;
                  border: 1px solid #e5e7eb;
                  padding: 16px;
                  box-shadow: 0px 4px 0px rgba(0, 0, 0, 0.15) !important;
                "
                (click)="open=!open"
              >
                <div
                  appMargin
                  marginY="2"
                  class="ui primary header"
                  style="width: 80%; display: flex; align-items: center"
                >
                  <div fxFlex="20%">
                    <img
                      *ngIf="!data.photographDocumentPath"
                      src="assets/avatar/1.jpg"
                      alt=""
                      class="ui small circular image"
                    />
                    <img
                      *ngIf="data.photographDocumentPath"
                      src="{{baseUrl}}/public/image/?media={{data.photographDocumentPath}}"
                      class="ui mini image image-large"
                    />
                  </div>
                  <div style="margin-left: 20px">
                    <p
                      *ngIf="data.actionType && data.actionType !=='NONE'"
                      style="
                        font-family: 'Roboto';
                        font-style: normal;
                        font-weight: 500;
                        font-size: 10px;
                        line-height: 19px;
                        color: #505050;
                      "
                    >
                      {{ data.actionType}} Request
                    </p>
                    <p
                      style="
                        font-family: 'Roboto';
                        font-style: normal;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 19px;
                        color: #505050;
                        margin: 0;
                        padding-bottom: 10px;
                      "
                    >
                      {{ data.firstName}} {{ data.lastName}}
                    </p>
                    <p
                      *ngIf="type==='SHAREHOLDER_STRUCTURE'"
                      style="
                        font-family: 'Roboto';
                        font-style: normal;
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 19px;
                        color: #505050;
                      "
                    >
                      Shareholding Amount: {{ returnPercent(data.shareholding)}}
                    </p>
                  </div>
                </div>
                <div class="stay-right">
                  <button
                    class="ui right floated circular icon button light-bg"
                  >
                    <i
                      [ngClass]="{ activeTab: open}"
                      class="chevron down icon"
                      appMargin
                      marginR="5px"
                    ></i>
                  </button>
                </div>
              </div>
              <div
                content
                class="sub-item"
                style="background: #f9fafb; border-radius: 4px; padding: 16px"
                appMargin
                marginB="2"
              >
                <div class="item" style="margin-bottom: 30px">
                  <h4
                    *ngIf="data.shareholding"
                    style="
                      font-weight: 700;
                      font-size: 11px;
                      line-height: 131.69%;
                      color: #505050;
                    "
                  >
                    Entity type
                  </h4>
                  <p
                    *ngIf="data.shareholding"
                    style="
                      font-weight: 400;
                      font-size: 14px;
                      line-height: 19px;
                      color: #505050;
                      margin-top: '-5px';
                    "
                  >
                    {{data.companyName &&
                    data.companyRegNumber?'Company':'Individual'}}
                  </p>
                </div>
                <div
                  class="item"
                  *ngFor="let el of  data| keyvalue"
                  style="margin-bottom: 30px"
                >
                  <h4
                    style="
                      font-weight: 700;
                      font-size: 11px;
                      line-height: 131.69%;
                      color: #505050;
                    "
                  >
                    {{ directorValue(el.key,data.companyName &&
                    data.companyRegNumber,el)}}
                  </h4>
                  <p
                    style="
                      font-weight: 400;
                      font-size: 14px;
                      line-height: 19px;
                      color: #505050;
                      margin-top: '-5px';
                    "
                  >
                    {{el.key==='shareholding' && type!=='DIRECTOR_STRUCTURE'&&
                    type!=='COMPANY
                    SECRETARY_STRUCTURE'?returnPercent(el.value):showValueDirector(el)}}
                  </p>
                </div>
              </div>
            </sui-accordion-panel>
          </sui-accordion>
        </div>
        <app-no-record-found
          *ngIf="fromValue && fromValue.length < 1"
        ></app-no-record-found>
        <h2
          style="
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;
            color: #3f4395;
          "
        >
          Current {{getType(type) | titlecase}} Records
        </h2>
        <div *ngFor="let data of toValue; let i=index;">
          <sui-accordion [closeOthers]="false">
            <sui-accordion-panel [isOpen]="false">
              <div
                title
                [ngClass]="{
                  '#e5e7eb':open,
                  '#f9fafb': !open
                }"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  height: 89px;
                  background-color: #f9fafb;
                  border: 1px solid #e5e7eb;
                  padding: 16px;
                  box-shadow: 0px 4px 0px rgba(0, 0, 0, 0.15) !important;
                "
                (click)="open=!open"
              >
                <div
                  appMargin
                  marginY="2"
                  class="ui primary header"
                  style="width: 80%; display: flex; align-items: center"
                >
                  <div fxFlex="20%">
                    <img
                      *ngIf="!data.photographDocumentPath"
                      src="assets/avatar/1.jpg"
                      alt=""
                      class="ui small circular image"
                    />
                    <img
                      *ngIf="data.photographDocumentPath"
                      src="{{baseUrl}}/public/image/?media={{data.photographDocumentPath}}"
                      class="ui mini image image-large"
                    />
                  </div>
                  <div style="margin-left: 20px">
                    <p
                      *ngIf="data.actionType && data.actionType !=='NONE'"
                      style="
                        font-family: 'Roboto';
                        font-style: normal;
                        font-weight: 500;
                        font-size: 10px;
                        line-height: 19px;
                        color: #505050;
                      "
                    >
                      {{ data.actionType}} Request
                    </p>
                    <p
                      style="
                        font-family: 'Roboto';
                        font-style: normal;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 19px;
                        color: #505050;
                      "
                    >
                      {{ data.firstName}} {{ data.lastName}}
                    </p>
                    <p
                      *ngIf="type==='SHAREHOLDER_STRUCTURE'"
                      style="
                        font-family: 'Roboto';
                        font-style: normal;
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 19px;
                        color: #505050;
                      "
                    >
                      Shareholding Amount: {{ returnPercent(data.shareholding)}}
                    </p>
                  </div>
                </div>
                <div class="stay-right">
                  <button
                    class="ui right floated circular icon button light-bg"
                  >
                    <i
                      [ngClass]="{ activeTab: open}"
                      class="chevron down icon"
                      appMargin
                      marginR="5px"
                    ></i>
                  </button>
                </div>
              </div>
              <div
                content
                class="sub-item"
                style="background: #f9fafb; border-radius: 4px; padding: 16px"
                appMargin
                marginB="2"
              >
                <div class="item" style="margin-bottom: 30px">
                  <h4
                    *ngIf="data.shareholding"
                    style="
                      font-weight: 700;
                      font-size: 11px;
                      line-height: 131.69%;
                      color: #505050;
                    "
                  >
                    Entity type
                  </h4>
                  <p
                    *ngIf="data.shareholding"
                    style="
                      font-weight: 400;
                      font-size: 14px;
                      line-height: 19px;
                      color: #505050;
                      margin-top: '-5px';
                    "
                  >
                    {{data.companyName &&
                    data.companyRegNumber?'Company':'Individual'}}
                  </p>
                </div>
                <div
                  class="item"
                  *ngFor="let el of  data| keyvalue"
                  style="margin-bottom: 30px"
                >
                  <h4
                    style="
                      font-weight: 700;
                      font-size: 11px;
                      line-height: 131.69%;
                      color: #505050;
                    "
                  >
                    {{ directorValue(el.key,data.companyName &&
                    data.companyRegNumber,el)}}
                  </h4>
                  <p
                    style="
                      font-weight: 400;
                      font-size: 14px;
                      line-height: 19px;
                      color: #505050;
                      margin-top: '-5px';
                    "
                  >
                    {{el.key==='shareholding' &&
                    type==='SHAREHOLDER_STRUCTURE'?returnPercent(el.value):showValueDirector(el)}}
                  </p>
                </div>
              </div>
            </sui-accordion-panel>
          </sui-accordion>
        </div>
        <app-no-record-found
          *ngIf="toValue && toValue.length < 1"
        ></app-no-record-found>
      </div>
      <div class="info" *ngIf="type==='CONTACT_INFORMATION'">
        <h2
          style="
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;
            color: #3f4395;
          "
        >
          Contact Information
        </h2>
        <div class="ui divider"></div>
        <div
          class="item"
          *ngFor="let el of toValue | keyvalue"
          style="margin-bottom: 30px"
        >
          <h4
            style="
              font-weight: 700;
              font-size: 11px;
              line-height: 131.69%;
              color: #505050;
            "
          >
            {{ contactValue(el.key)}}
          </h4>
          <p
            style="
              font-weight: 400;
              font-size: 14px;
              line-height: 19px;
              color: #505050;
              margin-top: '-5px';
            "
          >
            {{el.value}}
          </p>
        </div>
      </div>
      <div class="info" *ngIf="type==='COMPANY_NAME' && toValue?.companyName">
        <h2
          style="
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;
            color: #3f4395;
          "
        >
          Company Name
        </h2>
        <div class="ui divider"></div>
        <div
          class="item"
          *ngFor="let el of toValue | keyvalue"
          style="margin-bottom: 30px"
        >
          <h4
            style="
              font-weight: 700;
              font-size: 11px;
              line-height: 131.69%;
              color: #505050;
            "
          >
            COMPANY NAME
          </h4>
          <p
            style="
              font-weight: 400;
              font-size: 14px;
              line-height: 19px;
              color: #505050;
              margin-top: '-5px';
            "
          >
            {{el.value}}
          </p>
        </div>
      </div>
      <div
        class="info"
        *ngIf="(type==='TIN'|| type==='OTHER_TIN') && toValue?.tinNumber"
      >
        <h2
          style="
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;
            color: #3f4395;
          "
        >
          {{type==='OTHER_TIN'?'COMPANY OTHER TIN':'COMPANY TIN'}}
        </h2>
        <div class="ui divider"></div>
        <div
          class="red_message"
          *ngIf="this.tinNumber && this.toValue.tinNumber"
          [ngClass]="{'red_message_tin':!this.getIfTinMatch(),'green_message':this.getIfTinMatch()}"
        >
          <img
            *ngIf="!this.getIfTinMatch()"
            src="assets/icons/red_icon.svg"
            alt="error"
          />
          <img
            *ngIf="this.getIfTinMatch()"
            src="assets/icons/green_icon.svg"
            alt="error"
          />
          <p *ngIf="!this.getIfTinMatch()">TIN does not match FIRS records.</p>
          <p *ngIf="this.getIfTinMatch()">TIN matches FIRS records.</p>
        </div>
        <table
          class="custom-table"
          *ngIf="toValue.firsRecord  && type !== 'OTHER_TIN'"
        >
          <thead>
            <tr>
              <th></th>
              <th>Company Record</th>
              <th>Company Record from FIRS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Company Name</td>
              <td>{{companyOrganization.companyName}}</td>
              <td>{{toValue.firsRecord.TaxPayerName}}</td>
            </tr>
            <tr>
              <td>Tin Number</td>
              <td>{{toValue.tinNumber}}</td>
              <td>{{toValue.tinNumber}}</td>
            </tr>
            <tr>
              <td>RC Number</td>
              <td>{{companyOrganization.rcNumber}}</td>
              <td>{{toValue.firsRecord.RCNumber.replace("RC", "")}}</td>
            </tr>
          </tbody>
        </table>
        <div class="item" style="margin-bottom: 30px">
          <h4
            style="
              font-weight: 700;
              font-size: 11px;
              line-height: 131.69%;
              color: #505050;
            "
          >
            COMPANY TIN NUMBER
          </h4>
          <p
            style="
              font-weight: 400;
              font-size: 14px;
              line-height: 19px;
              color: #505050;
              margin-top: '-5px';
            "
          >
            {{toValue.tinNumber}}
          </p>
        </div>
      </div>
      <div class="info" *ngIf="type==='ADDRESS'">
        <h2
          style="
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;
            color: #3f4395;
          "
        >
          Company Address
        </h2>
        <div class="ui divider"></div>
        <div
          class="item"
          *ngFor="let el of toValue | keyvalue"
          style="margin-bottom: 30px"
        >
          <h4
            style="
              font-weight: 700;
              font-size: 11px;
              line-height: 131.69%;
              color: #505050;
            "
          >
            {{ addressValue(el.key)}}
          </h4>
          <p
            style="
              font-weight: 400;
              font-size: 14px;
              line-height: 19px;
              color: #505050;
              margin-top: '-5px';
            "
          >
            {{showValue(el)}}
          </p>
        </div>
      </div>
      <ng-container *ngIf="toValue && type == 'OTHER_TCC'">
        <div class="ui divider"></div>
        <div appPadding paddingB="16px">
          <sui-accordion [closeOthers]="false">
            <sui-accordion-panel [isOpen]="false">
              <div
                title
                [ngClass]="{
                      '#e5e7eb': open,
                      '#f9fafb': !open
                    }"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  height: 113px;
                  background-color: #f9fafb;
                  padding: 16px;
                  border-left: 1px solid #ecedef;
                  box-shadow: 0px 2px 4px 0px #00000040 !important;
                "
                (click)="open = !open"
                fxLayout="row"
                fxLayoutAlign="space-between center"
              >
                <div fxFlex="grow">
                  <div fxLayout="column">
                    <h3
                      appMargin
                      marginB="0"
                      class="card-label-1"
                      style="
                        text-transform: capitalize;
                        font-family: Roboto;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 18.75px;
                        text-align: left;
                        color: #505050;
                      "
                    >
                      {{ toValue?.year | date: "y" }}
                    </h3>
                    <div fxLayout="row" appMargin marginB="12px">
                      <small
                        class="card-label-2 light"
                        appMargin
                        marginR="10px"
                        style="
                          padding-top: 10px;
                          font-family: Roboto;
                          font-size: 14px;
                          font-weight: 400;
                          line-height: 16.41px;
                          text-align: left;
                          color: #9fa0b8;
                        "
                      >
                        TAX PAID: {{ toValue?.taxPaid | currency:
                        "NGN":"symbol-narrow" }}
                      </small>
                    </div>
                  </div>
                </div>

                <div fxFlex="20%" fxLayoutAlign="end">
                  <i
                    [ngClass]="{ activeTab: open, right: !open, up: open }"
                    class="chevron icon one"
                    appMargin
                    marginR="5px"
                  ></i>
                </div>
              </div>

              <div
                content
                class="sub-item"
                style="background: #f9fafb; border-radius: 4px"
                appMargin
                marginB="2"
              >
                <div class="ui bottom attached basic segment">
                  <div appMargin marginB="15px">
                    <div class="ui heading">TOTAL PROFIT</div>
                    <div class="ui heading-bottom">
                      {{ toValue?.totalProfit | currency: "NGN":"symbol-narrow"
                      }}
                    </div>
                  </div>

                  <div appMargin marginB="15px">
                    <div class="ui heading">ACCESSIBLE PROFIT</div>
                    <div class="ui heading-bottom">
                      {{ toValue?.assessableProfit | currency:
                      "NGN":"symbol-narrow" }}
                    </div>
                  </div>

                  <div appMargin marginB="15px">
                    <div class="ui heading">TURNOVER</div>
                    <div class="ui heading-bottom">
                      {{ toValue?.turnOver | currency: "NGN":"symbol-narrow" }}
                    </div>
                  </div>

                  <div appMargin marginB="15px">
                    <div class="ui heading">TAX PAID</div>
                    <div class="ui heading-bottom">
                      {{ toValue?.taxPaid | currency: "NGN":"symbol-narrow" }}
                    </div>
                  </div>
                </div>
              </div>
            </sui-accordion-panel>
          </sui-accordion>
        </div>
        <app-no-record-found
          *ngIf="fromValue && fromValue.length < 1"
        ></app-no-record-found>
      </ng-container>
      <div class="info" *ngIf="type==='EQUIPMENT'">
        <h2
          style="
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;
            color: #3f4395;
          "
        >
          Equipment Details
        </h2>
        <div class="ui divider"></div>
        <div *ngIf="toValue.length>1">
          <div *ngFor="let el of toValue " style="margin-bottom: 30px">
            <div
              class="item"
              *ngFor="let data of el.data | keyvalue"
              style="margin-bottom: 30px"
            >
              <h4
                style="
                  font-weight: 700;
                  font-size: 11px;
                  line-height: 131.69%;
                  color: #505050;
                "
              >
                {{ data.key}}
              </h4>
              <p
                style="
                  font-weight: 400;
                  font-size: 14px;
                  line-height: 19px;
                  color: #505050;
                  margin-top: '-5px';
                "
              >
                {{data.key==='equipTypeId'?(data.value.replaceAll('_', '
                ')):data.value}}
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="toValue.equipName">
          <div
            class="item"
            *ngFor="let data of toValue | keyvalue"
            style="margin-bottom: 30px"
          >
            <h4
              style="
                font-weight: 700;
                font-size: 11px;
                line-height: 131.69%;
                color: #505050;
              "
            >
              {{ equipmentValue(data.key)}}
            </h4>
            <p
              style="
                font-weight: 400;
                font-size: 14px;
                line-height: 19px;
                color: #505050;
                margin-top: '-5px';
              "
            >
              {{filterEquip(data)}}
            </p>
          </div>
        </div>
      </div>
      <div class="info" *ngIf="type==='RC_NUMBER'">
        <h2
          style="
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;
            color: #3f4395;
          "
        >
          Company Registration Details
        </h2>
        <div class="ui divider"></div>
        <div
          class="item"
          *ngFor="let el of toValue | keyvalue"
          style="margin-bottom: 30px"
        >
          <h4
            style="
              font-weight: 700;
              font-size: 11px;
              line-height: 131.69%;
              color: #505050;
            "
          >
            {{rename(el.key)}}
          </h4>
          <p
            style="
              font-weight: 400;
              font-size: 14px;
              line-height: 19px;
              color: #505050;
              margin-top: '-5px';
            "
          >
            {{el.key==='dateOfRegistration'?(el.value| date:'d, MMMM
            y'):value(el)}}
          </p>
        </div>
      </div>
      <app-field-registration-details-verify-cac
        [companies]="companies"
        [type]="type"
        [org]="companyOrg"
        [tinNumber]="tinNumber"
        [pending]="pending"
      ></app-field-registration-details-verify-cac>
      <div class="document">
        <h2
          style="
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;
            color: #3f4395;
          "
        >
          {{ type==='OFFICIAL_DOCUMENT'?"Document Uploaded": 'Supporting
          Documents'}}
        </h2>
        <app-no-record-found *ngIf="documents?.length<1"></app-no-record-found>
        <div *ngIf="documents?.length>0">
          <div
            style="
              display: flex;
              justify-content: space-between;
              flex-direction: column;
              margin-bottom: 15px;
            "
            *ngFor="let docType of groupedDocuments; let i=index;"
          >
            <div fxLayout="row" style="width: 100%">
              <h2
                *ngIf="type!=='OFFICIAL_DOCUMENT'"
                class="ui head"
                fxFlex="auto"
                style="
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 19px;
                  color: #3f4395;
                "
              >
                {{ docType.key }}
              </h2>
              <h2
                *ngIf="type==='OFFICIAL_DOCUMENT'"
                class="ui head"
                fxFlex="auto"
                style="
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 19px;
                  color: #3f4395;
                "
              >
                {{ toValue?.documentTypeName }}
              </h2>
            </div>
            <div
              style="width: 100%"
              class="ui divider"
              appMargin
              marginT="1"
            ></div>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 50px;
              "
              *ngFor="let doc of docType.value; let i=index;"
            >
              <div style="display: flex; align-items: center">
                <img
                  src="../../../../../assets/icons/document.svg"
                  alt="data"
                />
                <p
                  *ngIf="type==='OFFICIAL_DOCUMENT'"
                  style="
                    margin-left: 20px;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 16px;
                    color: #505050;
                  "
                >
                  {{ toValue?.documentName}}
                </p>
                <p
                  *ngIf="type!=='OFFICIAL_DOCUMENT'"
                  style="
                    margin-left: 20px;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 16px;
                    color: #505050;
                  "
                >
                  {{ doc.documentName}}
                </p>
              </div>
              <div>
                <button
                  (click)="viewDocument(doc)"
                  style="background: transparent; border: none"
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="View Document"
                >
                  <i class="eye icon"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="verify('Decline')">
    Decline Update
  </button>
  <button
    class="ui primary button"
    [ngClass]="{'yellow':pending}"
    [disabled]="isButtonDisabled()"
    (click)="notifyUser('Accept')"
    autofocus
  >
    Accept Update
  </button>
</div>
